import { render, staticRenderFns } from "./ListProductsIndex.vue?vue&type=template&id=63f5d538&scoped=true&"
import script from "./ListProductsIndex.vue?vue&type=script&lang=js&"
export * from "./ListProductsIndex.vue?vue&type=script&lang=js&"
import style0 from "./ListProductsIndex.vue?vue&type=style&index=0&id=63f5d538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5d538",
  null
  
)

export default component.exports